import { Bot, PencilLine, ScanBarcode, ShieldCheck } from 'lucide-react'
import type { ReactNode } from 'react'

import type { ProvenanceEntry } from '@aeris/contracts'

/**
 * De onde veio este valor (F108).
 *
 * Existe porque a decisão do dono é que a IA publique sozinha quando tudo
 * confere e peça revisão quando ela ESTIMOU — e quem revisa precisa ver, no
 * campo, qual dos dois é. Um peso que alguém pesou e um peso que um modelo
 * chutou são o mesmo número na tela e coisas opostas na conta do frete.
 *
 * **Ícone e texto, nunca só cor** (docs/UI_UX.md, seção de feedback): "IA ·
 * estimado" precisa ser legível para quem não distingue as cores e para quem
 * imprime a tela.
 */

const LABELS: Record<ProvenanceEntry['source'], string> = {
  manual: 'digitado',
  imported: 'importado',
  gtin_catalog: 'catálogo GTIN',
  marketplace_catalog: 'catálogo do canal',
  ai_estimated: 'IA · estimado',
  ai_researched: 'IA · pesquisado',
  reviewed: 'revisado',
}

const ICONS: Record<ProvenanceEntry['source'], typeof Bot> = {
  manual: PencilLine,
  imported: ScanBarcode,
  gtin_catalog: ScanBarcode,
  marketplace_catalog: ScanBarcode,
  ai_estimated: Bot,
  ai_researched: Bot,
  reviewed: ShieldCheck,
}

export type ProvenanceChipProps = {
  /** Ausente é "ninguém preencheu ainda" — e aí não há o que dizer. */
  provenance?: ProvenanceEntry | null | undefined
}

export const ProvenanceChip = ({
  provenance,
}: ProvenanceChipProps): ReactNode => {
  if (provenance == null) return null

  const Icon = ICONS[provenance.source]
  const confidence =
    provenance.confidence === null
      ? ''
      : ` ${provenance.confidence.toLocaleString('pt-BR', {
          minimumFractionDigits: 1,
          maximumFractionDigits: 2,
        })}`

  return (
    <span className="inline-flex items-center gap-1 text-(length:--text-xs) text-(--text-muted)">
      <Icon aria-hidden="true" className="size-3" />
      {LABELS[provenance.source]}
      {confidence}
    </span>
  )
}
